import script from "./LandingEN.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingEN.vue?vue&type=script&setup=true&lang=js"

import "./LandingEN.vue?vue&type=style&index=0&id=62b3fda8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b3fda8"]])

export default __exports__